import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ServicesSection from "./components/ServicesSection";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import LocalAreaSection, { landmarks as keywestLandmarks } from "./components/LocalAreaSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FinalCTA from "./components/FinalCTA";
import KeyWestTravelTimingSection from "./components/TravelTimingSection";
import KeyWestDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Key West, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Key West, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Florida Keys.";

const areaServedList = [
  { "@type": "City", name: "Key West" },
  { "@type": "City", name: "Stock Island" },
  { "@type": "City", name: "Big Coppitt Key" },
  { "@type": "City", name: "Sugarloaf Key" },
  { "@type": "City", name: "Marathon" },
  { "@type": "City", name: "Cudjoe Key" },
  { "@type": "City", name: "Big Pine Key" },
  { "@type": "AdministrativeArea", name: "Monroe County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Key West, Stock Island, Marathon, and Monroe County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const keyWestServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function KeyWestPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Key West"
        state="Florida"
        stateAbbr="FL"
        route="/cities/key-west"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Key West, Florida"
        geoPosition="24.5551;-81.7800"
        keywords="expedited passport Key West, emergency passport Key West FL, same day passport Key West, fast passport Florida Keys, passport renewal Key West, Key West passport courier"
        faqs={faqs}
        servicesSchema={keyWestServices}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={keywestLandmarks}
      />
      <HeroSection />
      <StickyNav />
      <LocalAreaSection />
      <ProcessingTimeSection />
      <ServicesSection />
      <KeyWestTravelTimingSection />
      <KeyWestDestinationsSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <HowItWorksSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/key-west" state="FL" />
      <FinalCTA />
    </div>
  );
}